import { ScheduledQueryDrawerSource } from '@terminal/services/tracking/posthog/use-posthog-events/types';
import { create } from '@terminal/utils/store/createStore';
import type { WebSearch } from '@terminal/views/alfred/research/services/conversations-service';

interface ScheduleDrawerState {
  isOpen: boolean;
  editingTaskId: string | null;
  initialQuery: string | null;
  priorWebSearch: WebSearch | null;
  trackingSource: ScheduledQueryDrawerSource | null;
  drawerKey: number;
}

interface ScheduleDrawerActions {
  open: (
    trackingSource: ScheduledQueryDrawerSource,
    query?: string,
    priorWebSearch?: WebSearch
  ) => void;
  openForEdit: (
    trackingSource: ScheduledQueryDrawerSource,
    taskId: string
  ) => void;
  close: () => void;
}

type ScheduleDrawerStore = ScheduleDrawerState & ScheduleDrawerActions;

export const useScheduleDrawerStore = create<ScheduleDrawerStore>(
  (set, get) => ({
    editingTaskId: null,
    initialQuery: null,
    priorWebSearch: null,
    trackingSource: null,
    isOpen: false,
    drawerKey: 0,
    open: (trackingSource, query?, priorWebSearch?) =>
      set({
        isOpen: true,
        editingTaskId: null,
        initialQuery: query ?? null,
        priorWebSearch: priorWebSearch ?? null,
        trackingSource,
        drawerKey: get().drawerKey + 1,
      }),
    openForEdit: (trackingSource, taskId) =>
      set({
        isOpen: true,
        editingTaskId: taskId,
        initialQuery: null,
        priorWebSearch: null,
        trackingSource,
        drawerKey: get().drawerKey + 1,
      }),
    close: () =>
      set({
        isOpen: false,
        editingTaskId: null,
        initialQuery: null,
        priorWebSearch: null,
        trackingSource: null,
      }),
  })
);
